import React from 'react';
import { Button, useUiLabel } from '@canvas-logic/clp-shared-ui';
import { Popover } from '@/ui-kit/components/Popover';
import TooltipContainer from '@/ui-kit/components/Tooltip/TooltipContainer';
import { useGetPdf } from '@/ui-kit/hooks/use-get-pdf';

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
interface PdfDownloadButtonProps {}

type PdfDownloadButtonIcon = 'pdf' | 'spinner' | 'check';

const PdfDownloadButton: React.FC<PdfDownloadButtonProps> = () => {
  const { state, generate } = useGetPdf();
  const downloadStartedToast = useUiLabel('ui.pdf.downloadStartedToast');

  const getButtonIcon = (): PdfDownloadButtonIcon => {
    switch (state) {
      case 'loading':
        return 'spinner';
      case 'ready':
        return 'check';
      default:
        return 'pdf';
    }
  };

  return (
    <Popover
      isDisabled={state !== 'ready'}
      content={<TooltipContainer>{downloadStartedToast}</TooltipContainer>}
      animate
      initialIsOpen={true}
      trigger="none"
      placement="bottom"
      useProvidedRoot
    >
      <Button variant="ternary" onClick={generate} disabled={state === 'loading'} iconStart={getButtonIcon()} />
    </Popover>
  );
};

export default PdfDownloadButton;
